// sections are global common margins between UI blocks

const sections = {
  xssSection: {
    marginTop: '5px'
  },
  xsSection: {
    marginTop: '10px'
  },
  smSection: {
    marginTop: '18px'
  },
  mdSection: {
    marginTop: '24px'
  },
  lgSection: {
    marginTop: '32px'
  },
  xlSection: {
    marginTop: '40px'
  },
  xxlSection: {
    marginTop: '48px'
  }
};
export default sections;